import * as qs from 'qs';
import { Api as apiService } from '../api';
export class BillApi {
    static getAllBills(params) {
        const searchParams = qs.stringify(params);
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/bills?${searchParams}`));
    }
    static getBill(bill_id) {
        return apiService.responseToJSONAndToastError(apiService.get('/api/web/bill/' + bill_id));
    }
    static getBillingCredits() {
        return apiService.responseToJSONAndToastError(apiService.get('/api/web/bill_user_credits'));
    }
    static getSubscription() {
        return apiService.responseToJSONAndToastError(apiService.get('/api/web/bills/subscription'));
    }
    static createSubscription(billingPlan, createSetupIntent = false) {
        return apiService.responseToJSONAndToastError(apiService.post('/api/web/bills/subscription', { billingPlan, createSetupIntent }));
    }
    static getInProgressSetupIntent() {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/bills/subscription/setup`));
    }
    static cancelSetupIntent(setupIntentId) {
        return apiService.responseToJSONAndToastError(apiService.delete(`/api/web/bills/subscription/setup/${setupIntentId}`));
    }
    static createSetupIntent(subscriptionId) {
        const searchParams = qs.stringify({ subscription_id: subscriptionId });
        return apiService.responseToJSONAndToastError(apiService.post(`/api/web/bills/subscription/setup?${searchParams}`, {}));
    }
    static updatePaymentMethod(paymentMethodId, subscriptionId) {
        const searchParams = qs.stringify({ subscription_id: subscriptionId });
        return apiService.responseToJSONAndToastError(apiService.post(`/api/web/bills/subscription/paymentMethod?${searchParams}`, {
            paymentMethodId: paymentMethodId
        }));
    }
    static getEstimatedTax(subscriptionAmount, implementationAmount = 0) {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/bills/estimated_tax?subscription_amount=${subscriptionAmount}&implementation_amount=${implementationAmount}`));
    }
    /**
     * Retrieve Stripe pricing tiers for a given plan ID
     * @param planId - The billing plan ID to fetch pricing tiers for
     * @returns Promise containing array of Stripe pricing tiers from the usage product
     */
    static getStripePriceTiersByBillingPlanId(planId) {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/bills/stripe/tiers/${planId}`));
    }
}
